import { img } from '@phi/components';
import contents from './coming_soon.svg';

export const coming_soon = (alt = '') => img(contents, `${alt} + (coming soon)`);
